import { showAlert } from '../../../utils/alerts';
import { axios } from '../../../utils/axios';

export const fetchStockPriceById = async (requestId) => {
  try {
    const { data } = await axios.get(
      `/costing-request/stock-price-extension-new-plants/${requestId}`,
    );
    return data.data;
  } catch (e) {
    showAlert(e, 'error');
  }
};
